import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 24px;
`

export const BodyParagraph = styled.p`
  margin: 0 0 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const BodyHighlight = styled.span`
  font-weight: 700;
`
